<div class="accessibility-selector"
     appMenuFocusHandler
     #focusHandler="menuFocusHandler">
  <button appMenuFocusParent
          class="link-item header-menu-link"
          [tabindex]="this.isFocusable | appIsFocusableTabIndex">
    <span>{{ 'accesibilitySettings.settings' | translate }}</span>
    <svg-icon class="icon-after" icon="arrow-right"></svg-icon>
  </button>

  <div class="menu-hover">
    <ul class="link-list">
      <li *ngFor="let setting of accessibilitySettings"
          [ngClass]="{ 'selected': setting.isTurnedOn }">
        <button id="{{setting.name}}"
                class="link-item"
                [ngClass]="{ 'selected': setting.isTurnedOn }"
                appMenuFocusTarget
                [focusHandler]="focusHandler"
                [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                (click)="toggleSetting(setting)">
          <span>{{ setting.title | translate }}</span>
          <svg-icon icon="checkmark" class="icon-tail" *ngIf="setting.isTurnedOn"></svg-icon>
        </button>
      </li>
    </ul>
  </div>
</div>
